<template>
  <component 
    :is="tag"
    v-on="$listeners" 
    class="rounded p-2 px-4 align-middle text-center hover:bg-opacity-90"
    :class="{
      'opacity-50 cursor-default': $attrs.disabled,
      'inline-block': anchor
    }"
  >
    <slot/>
  </component>
</template>

<script>
export default {
  props: {
    anchor: Boolean
  },
  computed: {
    tag() {
      return this.anchor ? 'a' : 'button'
    }
  }
}
</script>